import { values } from 'lodash'
import { stringWithoutSpecialCharacters } from 'utils/stringWithoutSpecialCharacters'
// we use stringWithoutSpecialCharacters to change venue label string in order to compare them
// with reports keys in store

export const getReportsByVenue = (state, venue) =>
  Object.values(state?.reports.byVenue?.[stringWithoutSpecialCharacters(venue)] ?? {})

export const getSelectedReportId = state => state?.reports?.selectedReportId ?? ''
export const getCurrentReport = (state, id, venueLabel) => {
  const allReports = values(getReportsByVenue(state, stringWithoutSpecialCharacters(venueLabel)))

  return allReports?.find(({ dashboardId }) => dashboardId === id) ?? {}
}

export const getIsLoadingReports = state => state?.reports.isLoading ?? false
